module.exports = __webpack_public_path__ + "static/details-5-bafa37693b110c762e07d704ec254afc.jpg";